import config from "../base/config"

let api = {
	baseUrl:config.BASE_URL,
	imgPath:"/guquan/sys/common/static/",
	filePath:config.BASE_URL+"/guquan/sys/common/static/",
	downloadPath:config.BASE_URL+"/guquan/sys/common/download/",
	public:{
		queryJumpImageList:"guquan/guquan/web/jumpImage/queryJumpImageList",  //弹窗广告
		queryPopMenuList:"guquan/guquan/web/jumpImage/queryPopMenuList",  //弹窗菜单
		getNavigation:"guquan/guquan/web/index/menuList", //获取导航
		getBanner:"guquan/guquan/web/index/bannerList", //获取轮播图
		queryContactPhoneList:"guquan/guquan/web/index/queryContactPhoneList", //获取服务电话
	},
	home:{
		getFrindLink:"guquan/guquan/web/index/friendshipList",   //友情链接
		getSpecial:"guquan/guquan/web/characteristicPlate/queryList", //特色板块
		getHomeRecommendNews:"guquan/guquan/web/news/queryNewsList",  //首页推荐新闻
		getHomeNews:"guquan/guquan/web/news/queryNewsType",  //首页获取新闻类型
		queryBusinessList:"guquan/guquan/web/news/queryBusinessList", //业务
		queryBusinessDetails:"guquan/guquan/web/news/queryBusinessDetails",  //业务介绍详情
	},
	news:{
		getRecommendNews:"guquan/guquan/web/news/queryNewsList", //获取推荐新闻
		getNewsInfo:"guquan/guquan/web/news/queryById",  //获取新闻详情
		getNewsType:"guquan/guquan/web/news/queryNewsType",  //获取新闻类型
		getSearchMenu:"guquan/guquan/web/news/querySearchMenu",  //新闻搜索菜单
		getNewsList:"guquan/guquan/web/news/queryNewsListByTypeId", //获取新闻列表
		queryFinanceType:"guquan/guquan/web/news/queryFinanceType",  //获取金融资产项目公告分类
		queryNewsListByTypeId:"guquan/guquan/web/news/queryNewsListByType", //获取新闻列表
	},
	service:{
		getServiceTypeList:"guquan/guquan/web/serviceType/queryList",  //获取服务分类
		getServiceList:"guquan/guquan/web/serviceType/queryCategoryList", //获取服务分类下的项目
		getServiceInfo:"guquan/guquan/web/serviceType/queryCategoryDetails", //获取服务详情
		queryCategoryDetailsNews:"guquan/guquan/web/serviceType/queryCategoryDetailsNews",
	},
	about:{
		getSwiper:"guquan/guquan/web/index/queryEnterpriseHonnerList",  //荣誉列表
	},
	search:{
		querySearchMenu:"guquan/guquan/web/news/querySearchMenu", //获取搜索菜单
		search:"guquan/guquan/web/news/search", //搜索新闻
	},
	roadshow:{
		getRoadShowTypes:"guquan/guquan/web/roadshow/queryRoadshowList",   //获取路演分类
		getOldRoadList:"guquan/guquan/web/roadshow/queryRoadshowActivityList",  //往期活动
		nearRoadList:"guquan/guquan/web/roadshow/list",  //近期活动
		queryRoadshowSpecialList:"guquan/guquan/web/roadshow/queryRoadshowSpecialList", //路演专题
		queryRoadshowTypeList:"guquan/guquan/web/roadshow/queryRoadshowTypeList", //路演类型
		queryRoadshowDetailsList:"guquan/guquan/web/roadshow/queryRoadshowDetailsList", //获取活动列表
		queryById:"guquan/guquan/web/roadshow/queryById",  //获取活动详情
		queryCompanyList:"guquan/guquan/web/roadshow/queryList",  //获取往期活动的公司
		queryListRpadshowDetails:"guquan/guquan/web/roadshow/queryListRpadshowDetails", //往期活动公司详情
		queryCalendar:"guquan/guquan/web/roadshow/queryCalendar", //活动日历
		sendPhone:"guquan/guquan/web/roadshow/sendPhone", //发送验证码
		roadshowSign:"guquan/guquan/web/roadshow/roadshowSign",  //路演报名
	},
	special:{
		getSpecialInfo:"guquan/guquan/web/characteristicPlate/queryPlateDetails",  //特色板块详情
	},
	boss:{
		queryBossBannerList:"guquan/guquan/web/bossBanner/queryBossBannerList",  //boss轮播图
		queryBossData:"guquan/guquan/web/bossBanner/queryBossData",  //boss数据
		queryMettingList:"guquan/guquan/web/bossBanner/queryMettingList", //早会
		quryAddressList:"guquan/guquan/web/bossBanner/quryAddressList", //获取学员地址
		queryStudentList:"guquan/guquan/web/bossBanner/queryStudentList", //获取学员列表
		sendPhone:"guquan/guquan/web/bossBanner/sendPhone", //发送验证码
		signUp:"guquan/guquan/web/bossBanner/signUp",  //报名
	},
	// 专精特新
	refined:{
		queryMasteryServiceList:"guquan/guquan/web/masteryActivity/queryMasteryServiceList",  //特色服务
		queryMasteryLoanList:"guquan/guquan/web/masteryActivity/queryMasteryLoanList", //贷款列表
		queryMasteryActivityPageList:"guquan/guquan/web/masteryActivity/queryMasteryActivityPageList", //活动列表
		queryACtivityDetailsById:"guquan/guquan/web/masteryActivity/queryACtivityDetailsById", //活动详情
		saveSignupByActivity:"guquan/guquan/web/masteryActivity/saveSignupByActivity", //提交活动报名
		queryCompanyType:"guquan/guquan/web/masteryActivity/queryCompanyType", //获取企业信息
		queryMasteryQuestionstemList:"guquan/guquan/web/masteryActivity/queryMasteryQuestionstemList", //获取题库
		queryAnswerScore:"guquan/guquan/web/masteryActivity/queryAnswerScore", //获得分数
		queryIntroduceList:"guquan/guquan/web/masteryActivity/queryIntroduceList", //获取入板列表
		queryIntroduceDetails:"guquan/guquan/web/masteryActivity/queryIntroduceDetails", //获取入板详情
	},
	// 上市联盟
	alliance:{
		unionMemberPageList:"guquan/guquan/mini/unionNews/unionMemberPageList", //联盟成员
		queryUnionServerList:"guquan/guquan/web/unionNews/queryUnionServerList", //上市服务
		unionDataList:"guquan/guquan/web/unionNews/unionDataList", //资料下载
		unionNewsList:"guquan/guquan/web/unionNews/Pagelist", //上市服务新闻列表
		queryNewsDetailsById:"guquan/guquan/web/unionNews/queryNewsDetailsById", //新闻详情
	}

}


export default api;


//////////////////
// WEBPACK FOOTER
// ./utils/api.js
// module id = null
// module chunks = 